import React from 'react'
import { env } from './env'

const EnvironmentContext = React.createContext(env)

export function useEnv() {
  return React.useContext(EnvironmentContext)
}
